import PropTypes from 'prop-types';
import * as React from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const propTypes = {
    accessibleText: PropTypes.string.isRequired,
    size: PropTypes.oneOf([
        'super',
        'standard',
        'mini',
        'tiny'
    ]),
    layout: PropTypes.oneOf([
        'vertical',
        'horizontal'
    ]),
    showText: PropTypes.bool,
    overlay: PropTypes.bool
};
const propKeysToRemove = Object.keys(propTypes);
const Spinner = renderWithRef('Spinner', propTypes, (props, ref)=>{
    const { size ='medium' , accessibleText , layout ='vertical' , showText =false , overlay =false  } = props;
    const classNames = new Set([]);
    classNames.add('swan-spinner');
    if (size !== 'standard') classNames.add(`swan-spinner-${size}`);
    if (layout === 'horizontal') classNames.add(`swan-spinner-horizontal`);
    if (showText) classNames.add(`swan-spinner-show-text`);
    if (overlay) classNames.add(`swan-spinner-overlay`);
    return /*#__PURE__*/ React.createElement(RenderComp, {
        root: "span",
        forwardedRef: ref,
        propKeysToRemove: propKeysToRemove,
        classNames: classNames,
        props: _object_spread({}, props)
    }, /*#__PURE__*/ React.createElement("span", {
        className: "swan-spinner-animation"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "swan-spinner-animation-inner"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "swan-spinner-text"
    }, accessibleText));
});

export { Spinner };
